
























































































import { Component, Vue } from 'vue-property-decorator';
import { Order, OrderItem } from '@/store/OrderModel';
import { OrderModule } from '@/store/OrderModule';

@Component
export default class Cart extends Vue {
  public get count() {
    return OrderModule.count;
  }

  public get items() {
    return OrderModule.items;
  }

  public get reduction() {
    return OrderModule.reduction;
  }

  public get total() {
    return OrderModule.total;
  }

  public deleteItem(item: OrderItem) {
    OrderModule.deleteOrderItem(item);
  }

  public changeQuantity(item: OrderItem, quantity: number) {
    OrderModule.changeQuantityOrderItem({ orderItem: item, quantity });
  }
}
